import React, { useContext, useRef, useState } from 'react';
import FilterIcon from '../../assets/Filter.svg';
import SearchIcon from '../../assets/Search.svg';
import FilterModal from '../FilterModal';
import UserFilterModal from '../../../manageUser/UserFilterModal/UserFilterModal';
import DownloadIcon from '../../assets/download-icon.svg';
import DropdownField from '../FormDropdown';
import { UserContext } from '../../service/userContext';
import { arrayofPreCheckEvaluationResult } from '../../utils/helper';

export const Search = (props) => {
  const inputRef = useRef(null);
  const { onChange } = props;
  return (
    <div
      style={{ marginLeft: '15px' }}
      className="d-flex justify-content-center align-items-center"
    >
      <input
        ref={inputRef}
        placeholder="Search"
        className="search-input align-self-center justify-self-center"
        onChange={onChange}
      />
      <img
        src={SearchIcon}
        className="search-icon"
        onClick={() => inputRef.current.focus()}
        alt="search"
      />
    </div>
  );
};

export const Filter = (props) => {
  const { toShowFilter, openModal } = props;

  return (
    <div
      onClick={openModal}
      style={{ marginLeft: '15px' }}
      className={`${
        toShowFilter ? 'd-flex' : 'd-none'
      } align-items-center ms-3 filter-div cursor-pointer`}
    >
      <img src={FilterIcon} alt="filters" />
      <span className="font-13 p-1">Filter</span>
    </div>
  );
};

export const Departments = (props) => {
  const { departments } = useContext(UserContext);
  const depts = departments?.filter((d) => d !== undefined);
  const allCodes = depts.map((dept) => dept.value);
  const [data, setData] = useState(allCodes);
  const { onChange } = props;
  return (
    <>
      <div
        style={{ marginLeft: '15px' }}
        className="dropdown-input d-flex align-items-center justify-content-center "
      >
        <div className="text-1 ">Department:</div>
        <div className="dept-header-dropdown">
          <DropdownField
            selectedOptions={data}
            allOptions={depts}
            arrowOutside
            lowerLevelClassName="inner-date-input p-0"
            multiselect
            handleChange={(fieldName, value, multiselect, isAll) => {
              if (isAll) {
                setData(allCodes);
                onChange(allCodes);
              } else {
                const newData = [...data];
                if (newData.includes(value)) {
                  newData.splice(newData.indexOf(value), 1); // Remove the field from newData
                  setData(newData);
                  onChange(newData);
                } else {
                  setData([...newData, value]);
                  onChange([...newData, value]);
                }
              }
            }}
          />
        </div>
      </div>
    </>
  );
};

const Status = (props) => {
  const evaluationStatuses = arrayofPreCheckEvaluationResult.map((status) => ({
    name: status,
    value: status,
  }));
  const [data, setData] = useState(arrayofPreCheckEvaluationResult);
  console.log({ evaluationStatuses, data });
  const { onChange } = props;
  return (
    <>
      <div
        style={{ marginLeft: '15px' }}
        className="dropdown-input d-flex align-items-center justify-content-center  "
      >
        <div className="text-1 me-2">Status:</div>
        <div className="header-dropdown">
          <DropdownField
            arrowOutside
            selectedOptions={data}
            allOptions={evaluationStatuses}
            lowerLevelClassName="inner-date-input p-0"
            multiselect
            fieldKey={'status'}
            handleChange={(fieldName, value, multiselect, isAll) => {
              if (isAll) {
                setData(arrayofPreCheckEvaluationResult);
                onChange(arrayofPreCheckEvaluationResult);
              } else {
                const newData = [...data];
                if (newData.includes(value)) {
                  newData.splice(newData.indexOf(value), 1); // Remove the field from newData
                  setData(newData);
                  onChange(newData);
                } else {
                  setData([...newData, value]);
                  onChange([...newData, value]);
                }
              }
            }}
          />
        </div>
      </div>
    </>
  );
};

export const Category = (props) => {
  const { licenses } = useContext(UserContext);

  const licensesOptions = licenses
    ?.map(({ name, code }) => ({ name, value: code }))
    ?.filter((d) => d != undefined);

  const allCodes = licenses?.map((l) => {
    return l.code;
  });
  const [data, setData] = useState(allCodes);
  const { onChange } = props;
  return (
    <>
      <div
        style={{ marginLeft: '15px' }}
        className="dropdown-input d-flex align-items-center justify-content-center "
      >
        <div className="text-1 ">Asset category:</div>
        <div className="dept-header-dropdown">
          <DropdownField
            arrowOutside
            selectedOptions={data}
            allOptions={licensesOptions}
            lowerLevelClassName="inner-date-input p-0"
            multiselect
            categoryText={props.categoryText}
            handleChange={(fieldName, value, multiselect, isAll) => {
              if (isAll) {
                setData(allCodes);
                onChange(allCodes);
              } else {
                const newData = [...data];
                if (newData.includes(value)) {
                  newData.splice(newData.indexOf(value), 1); // Remove the field from newData
                  setData(newData);
                  onChange(newData);
                } else {
                  setData([...newData, value]);
                  onChange([...newData, value]);
                }
              }
            }}
          />
        </div>
      </div>
    </>
  );
};

const Date = (props) => {
  const { setSelectedDate, selectedDate } = props;
  return (
    <>
      <div
        style={{ marginLeft: '15px' }}
        className="date-input d-flex align-items-center justify-content-center "
      >
        <div className="text-1 me-2">Date:</div>
        <input
          type="date"
          className="text-2 inner-date-input "
          value={selectedDate}
          onChange={(e) => {
            setSelectedDate(e.target.value);
          }}
        />
      </div>
    </>
  );
};

export const Download = ({ onDownloadClick }) => {
  return (
    <div onClick={onDownloadClick} className="d-flex align-items-center">
      <img
        src={DownloadIcon}
        alt="download"
        className="subheader-download ms-2 cursor-pointer"
      />
      <div style={{ fontSize: '12px' }}>Download</div>
    </div>
  );
};

const SubHeader = (props) => {
  const {
    userFilter,
    toShowFilter,
    SubHeaderVisible,
    onSearchChange,
    onDateChange,
    onDeptChange,
    onStatusChange,
    setFilteredData,
    filteredData,
    materialMovementFilterModal,
    onSaveClick = () => {},
    showDownload,
    onDownloadClick,
    hideSearch,
    date,
    department,
    status,
    selectedDate,
    setSelectedDate,
    outerClassName,
    category,
    onCategoryChange,
  } = props;

  const [openFilterModal, setOpenFilterModal] = useState(false);

  const saveAndClose = (filterData, hasFiltered) => {
    setOpenFilterModal(false);
    onSaveClick(filterData, hasFiltered);
  };

  return (
    <div
      className={`${
        SubHeaderVisible ? 'd-flex' : 'd-none'
      } align-items-center subheader me-3 ${outerClassName}`}
    >
      {date && (
        <Date selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
      )}
      {department && <Departments onChange={onDeptChange} />}
      {category && <Category onChange={onCategoryChange} />}
      {status && <Status onChange={onStatusChange} />}
      {!hideSearch && <Search onChange={onSearchChange} />}
      {showDownload && <Download />}
      <Filter
        userFilter={props.userFilter}
        filteredData={filteredData}
        toShowFilter={toShowFilter}
        openModal={() => setOpenFilterModal(true)}
      />

      {userFilter && openFilterModal ? (
        <UserFilterModal
          modalOpen={openFilterModal}
          modalToggle={() => setOpenFilterModal(false)}
          initialFilteredData={filteredData}
          setFilteredData={setFilteredData}
          onSaveClick={saveAndClose}
        />
      ) : openFilterModal ? (
        <FilterModal
          modalOpen={openFilterModal}
          modalToggle={() => setOpenFilterModal(false)}
          initialFilteredData={filteredData}
          onSaveClick={saveAndClose}
        />
      ) : null}
    </div>
  );
};

export default SubHeader;
